"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("better-auth/react");
var fetchWithTimeout = require("./fetchWithTimeout");
// The browser and auth API share an origin. The development webpack proxy and
// the deployment reverse proxy forward /api/auth to the Caroline auth server.
var carolineAuthClient = (0, react_1.createAuthClient)({
    // A stalled upstream must settle as unavailable rather than keep the UI
    // waiting indefinitely. Normal delayed responses remain valid in this window.
    fetchOptions: { customFetchImpl: fetchWithTimeout },
});
exports.default = carolineAuthClient;
